import { z } from 'zod';
import { dataHoraSchema, paginacaoSchema } from './comum.js';
/**
 * ============================================================================
 * CAPTACAO — leads, campanhas, passos e configuracoes JSON
 * ============================================================================
 *
 * Espelha o que `nyroh-leads` ja grava hoje, com tres diferencas:
 *
 *  1. `place_id` continua sendo a chave natural do lead (e o que garante
 *     idempotencia da varredura), mas agora e UNIQUE de verdade, nao convencao.
 *  2. Foto de lead nunca mais vai como base64 para o banco: vai para o R2 e o
 *     que fica na linha e a chave do objeto.
 *  3. Os nomes saem do snake_case do PostgREST. O front nao fala mais com o banco,
 *     entao nao ha razao para carregar a convencao de coluna ate a tela.
 */
export const statusCampanhaSchema = z.enum([
    'rascunho',
    'rodando',
    'pausada',
    'concluida',
    'falhou',
]);
export const passoCampanhaSchema = z.object({
    id: z.uuid(),
    campanhaId: z.string(),
    alvoId: z.string(),
    alvoNome: z.string(),
    regiaoId: z.string(),
    regiaoNome: z.string(),
    cidadeNome: z.string(),
    status: z.enum(['pendente', 'rodando', 'concluido', 'falhou', 'pulado']),
    leadsEncontrados: z.number().int().default(0),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    concluidoEm: dataHoraSchema.nullable(),
    /** Preenchido quando status = falhou. Antes isso sumia num catch vazio (BUG-6). */
    erro: z.string().nullable(),
});
export const campanhaSchema = z.object({
    id: z.string(),
    nome: z.string(),
    status: statusCampanhaSchema,
    indicePassoAtual: z.number().int().default(0),
    totalLeads: z.number().int().default(0),
    enriquecerAuto: z.boolean().default(false),
    criadoEm: dataHoraSchema,
    atualizadoEm: dataHoraSchema,
    passos: z.array(passoCampanhaSchema).default([]),
});
export const salvarCampanhaSchema = z.object({
    id: z.string().min(1),
    nome: z.string().min(1),
    status: statusCampanhaSchema.default('rascunho'),
    indicePassoAtual: z.number().int().default(0),
    totalLeads: z.number().int().default(0),
    enriquecerAuto: z.boolean().default(false),
    passos: z
        .array(passoCampanhaSchema.omit({ id: true, campanhaId: true }).partial({ erro: true }))
        .default([]),
    /** true substitui os passos existentes; false so faz upsert dos enviados. */
    substituirPassos: z.boolean().default(false),
});
export const leadSchema = z.object({
    placeId: z.string(),
    nome: z.string(),
    endereco: z.string().nullable(),
    telefone: z.string().nullable(),
    website: z.string().nullable(),
    nota: z.number().nullable(),
    totalAvaliacoes: z.number().int().nullable(),
    tipos: z.array(z.string()).default([]),
    campanhaId: z.string().nullable(),
    geometria: z.unknown().nullable(),
    /** Chaves no R2, nao base64 e nao URL — a URL e derivada no consumo. */
    fotos: z.array(z.string()).default([]),
    dadosWhatsapp: z.unknown().nullable(),
    varridoEm: dataHoraSchema,
});
export const salvarLeadsSchema = z.object({
    leads: z.array(leadSchema.partial({ varridoEm: true })).min(1).max(500),
});
export const filtroLeadsSchema = paginacaoSchema.extend({
    campanhaId: z.string().optional(),
    busca: z.string().optional(),
    comWhatsapp: z.boolean().optional(),
    nicho: z.string().optional(),
});
export const excluirLeadsSchema = z.object({
    placeIds: z.array(z.string()).min(1).max(1000),
});
/** Upload de foto de lead: o navegador manda bytes, o servidor devolve a chave R2. */
export const uploadFotoLeadSchema = z.object({
    placeId: z.string().min(1),
    /** data URL ou base64 puro. Convertido e descartado no servidor; nao e persistido. */
    conteudoBase64: z.string().min(1),
    sufixo: z.string().max(20).default(''),
});
export const resultadoUploadSchema = z.object({
    chaveR2: z.string(),
    url: z.string(),
    bytes: z.number().int(),
});
export const configJsonSchema = z.object({
    id: z.string(),
    nome: z.string(),
    tipo: z.string(),
    conteudo: z.unknown(),
    criadoEm: dataHoraSchema,
});
export const salvarConfigJsonSchema = configJsonSchema.omit({ criadoEm: true }).partial({
    id: true,
});
//# sourceMappingURL=captacao.js.map